import React, { useCallback, useRef } from "react";
import { Box } from "@mui/material";

const hideVerticalScrollbarSx = {
    overflowY: "auto",
    overflowX: "hidden",
    WebkitOverflowScrolling: "touch",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": { display: "none" },
};

/**
 * Vertical piece tray — landscape / 16:9 capture play.
 * `containerRef` is attached to the scroll element (hit-testing / drag offsets).
 */
export default function PieceTrayScrollColumn({
    children,
    containerRef,
    columnWidthPx,
    stripWidthPx,
    maxHeightPx,
    sx,
}) {
    const scrollRef = useRef(null);

    const setScrollEl = useCallback(
        (el) => {
            scrollRef.current = el;
            if (!containerRef) return;
            if (typeof containerRef === "function") {
                containerRef(el);
            } else {
                containerRef.current = el;
            }
        },
        [containerRef],
    );

    return (
        <Box
            ref={setScrollEl}
            sx={{
                height: "100%",
                maxHeight: maxHeightPx ?? "100%",
                width: stripWidthPx ?? columnWidthPx,
                maxWidth: stripWidthPx ?? columnWidthPx,
                flexShrink: 0,
                alignSelf: "stretch",
                position: "relative",
                pointerEvents: "auto",
                boxSizing: "border-box",
                touchAction: "pan-y",
                scrollbarGutter: "stable",
                ...hideVerticalScrollbarSx,
                ...sx,
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    flexWrap: "nowrap",
                    alignItems: "center",
                    height: "max-content",
                    minHeight: "100%",
                    width: columnWidthPx,
                    flexShrink: 0,
                    gap: 0,
                }}
            >
                {children}
            </Box>
        </Box>
    );
}
